import { computed, defineComponent } from 'vue'
import { type JSX } from 'vue/jsx-runtime'

import VTabButton from '@/components/common/button/VTabButton'
import { displayItem } from '@/utils/item'

interface Props {
  tData?: string
  class?: unknown
  subClass?: string
  items?: Array<Record<string, any>>
  itemText?: string
  itemKey?: string
  value: number
  onChange?: ((index: number, payload: MouseEvent) => void)
}

export default defineComponent<Props>((props) => {
  // #region Props Getters

  const tData = computed(() => props.tData ?? 'v-tabs')
  const itemText = computed((): string => props.itemText ?? 'text')
  const itemKey = computed((): string => props.itemKey ?? 'value')

  // #endregion

  // #region Getters

  const mappedTabs = computed((): JSX.Element[] | undefined => {
    return props.items?.map((tab, index) => (
      <VTabButton
        t-data={`${tData.value}-tab-btn`}
        key={`v-tabs-btn-${displayItem(tab, itemKey.value)}`}
        checked={props.value === index}
        onClick={(e) => props.onChange?.(index, e)}
      >
        {displayItem(tab, itemText.value)}
      </VTabButton>
    ))
  })

  // #endregion

  return () => (
    <div class={['mac-scrollbar relative w-full overflow-x-auto', props.class]}>
      <div class={['relative flex w-fit', props.subClass]}>
        <div class='pointer-events-none absolute left-0 top-0 block h-[2.3rem] w-full'>
          <div class='size-full border-b border-b-neutral-300' />
        </div>
        {mappedTabs.value}
      </div>
    </div>
  )
}, {
  name: 'VTabs',
  props: [
    'tData',
    'class',
    'subClass',
    'value',
    'items',
    'itemText',
    'itemKey',
    'onChange'
  ]
})
